import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { PortTile } from "../../../../components/subscription-detail/port-tile/port-tile";
import { AggspSubscriptionDetails } from "../../../../pages/subscription-detail/types";

@Component({
  selector: "link-member-subscriptions",
  templateUrl: "link-member-subscriptions.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, AngularSvgIconModule, PortTile],
})
export class LinkMemberSubscriptions {
  protected linkMemberSubscriptions = input.required<AggspSubscriptionDetails["linkMemberSubscriptions"]>();

  protected hasLinkMemberSubscriptions = computed(() => this.linkMemberSubscriptions().length > 0);
}
